import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
// import api from '../services/api/axios.config';
import { notify } from '../utils/methods/notification';
import httpService from '../../services/httpService';

const initialState = {
    isLoading: false,
    fetchEmailType: [],
    allEmailsTemplates:[],
    emailTemplateById:[],
    isExistTemplateType:[],
};

// fetch the all email types 
export const fetchEmailTypes = createAsyncThunk(
    'bmr/fetchEmailTypes',
    async (_, { rejectWithValue }) => {
        try {
            const response = await httpService.get('/get-communication-types');
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response ? error.response.data : error.message);
        }
    }
);

export const fetchWhatsAppTemplate = createAsyncThunk(
    'bmr/fetchWhatsAppTemplate',
    async (_, { rejectWithValue }) => {
        try {
            const response = await httpService.get('/whatsapp/template');
            return response.templates;
        } catch (error) {
            return rejectWithValue(error.response ? error.response.templates : error.message);
        }
    }
);

//@info handle create email template
export const createEmailTemplate = createAsyncThunk(
    'bmr/createEmailTemplate',
    async (args, { rejectWithValue }) => {
        try {
            const response = await httpService.post('/create-communication-template', args);
            notify.success(response.message);
            return response.data;
        } catch (error) {
            notify.error(error || error.message);
            return rejectWithValue(error.response ? error.response.data : error.message);
        }
    }
);


// fetch the all email types 
export const fetchAllEmailsTemplates = createAsyncThunk(
    'bmr/fetchAllEmailsTemplates',
    async (params, { rejectWithValue }) => {
        try {
            const response = await httpService.get('/get-communication-templates',{ params: params });
            return response;
        } catch (error) {
            return rejectWithValue(error.response ? error.response.data : error.message);
        }
    }
);

export const deleteEmailTemplate = createAsyncThunk(
    'bmr/deleteEmailTemplate',
    async (args, { rejectWithValue }) => {
        try {       
            const { id } = args;
            const response = await httpService.delete(`/delete-communication-template/${id}`);
            notify.success(response?.data?.message || "Deleted successfully");
            return response.data;
        } catch (error) {
            const message = error?.response?.data?.message || error?.message || "Something went wrong";
            notify.error(message);
            return rejectWithValue(message);
        }    
    }
);
// /get-template-detail/11
export const fetchEmailTemplateById = createAsyncThunk(
    'bmr/fetchEmailTemplateById',
    async (id, { rejectWithValue }) => {
        try {
            const response = await httpService.get(`/get-template-detail/${id}`);
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response ? error.response.data : error.message);
        }
    }
);

// /update-email-template/2
export const updateEmailTemplate = createAsyncThunk(
    'bmr/updateEmailTemplate',
    async ({ id, data }, { rejectWithValue }) => {
        try {
            const response = await httpService.post(
                `/update-communication-template/${id}`,
                data
            );
            notify.success(response.message);
            return response.data;
        } catch (error) {
            return rejectWithValue(error);
        }
    }
);

// /update-email-template/2
export const isExistTypeId = createAsyncThunk(
    'bmr/existing-template-by-type',
    async ({ id}, { rejectWithValue }) => {
        try {
            const response = await httpService.get(
                `/existing-template-by-type/${id}`);
            return response.data;
        } catch (error) {
            return rejectWithValue(
                error.response ? error.response.data : error.message
            );
        }
    }
);




const emailTemplatesSlice = createSlice({
    name: 'emailTemplates',
    initialState,  
    extraReducers: (builder) => {
        builder
            .addCase(fetchEmailTypes.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(fetchEmailTypes.fulfilled, (state, action) => {
                state.isLoading = false;
                state.fetchEmailType = action.payload.data
            })
            .addCase(fetchEmailTypes.rejected, (state) => {
                state.isLoading = false;
            })

            //@info slice for create Email template.
            .addCase(createEmailTemplate.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(createEmailTemplate.fulfilled, (state) => {
                // console.log('action', action)
                state.isLoading = false;
            })
            .addCase(createEmailTemplate.rejected, (state) => {
                state.isLoading = false;
            })
            // @info fetch all the 
             .addCase(fetchAllEmailsTemplates.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(fetchAllEmailsTemplates.fulfilled, (state, action) => {
                state.isLoading = false;
                state.allEmailsTemplates = action.payload
            })
            .addCase(fetchAllEmailsTemplates.rejected, (state) => {
                state.isLoading = false;
            })
            // @info fetch all the 
             .addCase(fetchEmailTemplateById.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(fetchEmailTemplateById.fulfilled, (state, action) => {
                state.isLoading = false;
                state.emailTemplateById = action.payload
            })
            .addCase(fetchEmailTemplateById.rejected, (state) => {
                state.isLoading = false;
            })
            
            // @info update email template 
             .addCase(updateEmailTemplate.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(updateEmailTemplate.fulfilled, (state) => {
                state.isLoading = false;
            })
            .addCase(updateEmailTemplate.rejected, (state) => {
                state.isLoading = false;
            })

            // @info exist email template 
             .addCase(isExistTypeId.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(isExistTypeId.fulfilled, (state,action) => {
                state.isLoading = false;
                state.isExistTemplateType=action.payload.data
            })
            .addCase(isExistTypeId.rejected, (state) => {
                state.isLoading = false;
            })
        }
    
});


export default emailTemplatesSlice.reducer;
